import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "radix-ui";
import { cn } from "@/lib/utils";
const badgeVariants = cva("inline-flex items-center justify-center rounded-full border border-transparent px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
      secondary: "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
      destructive: "bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
      outline: "border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
      ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
      link: "text-primary-dark underline-offset-4 [a&]:hover:underline"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function Badge(t0) {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      asChild: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const variant = t1 === undefined ? "default" : t1;
  const asChild = t2 === undefined ? false : t2;
  const Comp = asChild ? Slot.Root : "span";
  let t3;
  if ($[5] !== className || $[6] !== variant) {
    t3 = cn(badgeVariants({
      variant
    }), className);
    $[5] = className;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== Comp || $[9] !== props || $[10] !== t3 || $[11] !== variant) {
    t4 = <Comp data-slot="badge" data-variant={variant} className={t3} {...props} />;
    $[8] = Comp;
    $[9] = props;
    $[10] = t3;
    $[11] = variant;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export { Badge, badgeVariants };